import axios from 'axios'

export const state = {
  all: {},
  loaded: false,
}

export const getters = {
  getContentBlock(state) {
    return (key) => (state.all[key] ? state.all[key].content : '...')
  },
}

export const mutations = {
  SET_ALL(state, newContentBlocks) {
    state.all = newContentBlocks
      .map((block) => {
        return { [block.key]: block }
      })
      .reduce((a, b) => ({ ...a, ...b }), {})
  },
  SET_LOADED(state, newValue) {
    state.loaded = newValue
  },
}

export const actions = {
  fetchAll({ state, commit }) {
    if (state.loaded) return state.all

  /*  return axios
      .get('/api/content-blocks')
      .then((response) => {
        const { contentBlocks } = response.data
        commit('SET_ALL', contentBlocks)
        commit('SET_LOADED', true)
        return state.all
      })
      .catch((error) => {
        commit('SET_LOADED', true)
        console.error(error)
      }) */
  },
}
